import React from "react";
import TextField from "./TextField";

type Field = {
  label: string;
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
  options?: string[];
  style?: React.CSSProperties;

  uppercase?: boolean;
  contabil?: boolean;
  locked?: boolean;
  disabled?: boolean;
  date?: boolean;
  numericWithUnit?: boolean;

  button?: boolean;
  buttonText?: string;
  onButtonClick?: () => void;
  buttonWidth?: number | string;
  buttonDisabled?: boolean;
  buttonVariant?: "primary" | "secondary";

  secondButton?: boolean;
  secondButtonText?: string;
  onSecondButtonClick?: () => void;
  secondButtonWidth?: number | string;
  secondButtonDisabled?: boolean;
  secondButtonVariant?: "primary" | "secondary";
};

type TextFieldRowProps = {
  left?: Field;
  right?: Field;
  center?: Field;

  gap?: number;
  rowGap?: number;
  marginLeft?: number;
  marginTop?: number;
  marginBottom?: number;

  minItemWidth?: number | string;
  maxItemWidth?: number | string;

  wrap?: boolean;
  compact?: boolean;
};

const TextFieldRow: React.FC<TextFieldRowProps> = ({
  left,
  right,
  center,

  gap = 12,
  rowGap = 8,
  marginLeft = 0,
  marginTop = 0,
  marginBottom = 6,

  minItemWidth = 210,
  maxItemWidth,

  wrap = true,
  compact = true,
}) => {
  const toCssSize = (value: number | string) =>
    typeof value === "number" ? `${value}px` : value;

  const itemStyle: React.CSSProperties = {
    flex: center ? "1 1 100%" : "1 1 0",
    minWidth: toCssSize(minItemWidth),
    maxWidth: maxItemWidth ? toCssSize(maxItemWidth) : undefined,
    boxSizing: "border-box",
  };

  const rowBaseStyle: React.CSSProperties = {
    display: "flex",
    flexWrap: wrap ? "wrap" : "nowrap",
    columnGap: `${gap}px`,
    rowGap: `${rowGap}px`,
    marginLeft: `${marginLeft}px`,
    marginTop: `${marginTop}px`,
    marginBottom: `${marginBottom}px`,
    width: "100%",
    alignItems: "flex-start",
    boxSizing: "border-box",
  };

  const renderField = (field: Field) => {
    const mergedStyle: React.CSSProperties = {
      width: "100%",
      minHeight: compact ? 32 : undefined,
      fontSize: compact ? 12 : undefined,
      ...(field.style || {}),
    };

    return (
      <div style={itemStyle}>
        <TextField
          label={field.label}
          value={field.value}
          onChange={field.onChange}
          placeholder={field.placeholder}
          options={field.options}
          style={mergedStyle}
          uppercase={field.uppercase}
          contabil={field.contabil}
          locked={field.locked}
          disabled={field.disabled}
          date={field.date}
          numericWithUnit={field.numericWithUnit}
          button={field.button}
          buttonText={field.buttonText}
          onButtonClick={field.onButtonClick}
          buttonWidth={field.buttonWidth}
          buttonDisabled={field.buttonDisabled}
          buttonVariant={field.buttonVariant}
          secondButton={field.secondButton}
          secondButtonText={field.secondButtonText}
          onSecondButtonClick={field.onSecondButtonClick}
          secondButtonWidth={field.secondButtonWidth}
          secondButtonDisabled={field.secondButtonDisabled}
          secondButtonVariant={field.secondButtonVariant}
        />
      </div>
    );
  };

  if (center) {
    return <div style={rowBaseStyle}>{renderField(center)}</div>;
  }

  return (
    <div style={rowBaseStyle}>
      {left && renderField(left)}
      {right && renderField(right)}
    </div>
  );
};

export default TextFieldRow;
